export {
  WifiStatusIcon,
  RoommateNumberCountIcon,
  RoommateGenderIcon,
} from './FacilitiesIcon';
